import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { DialogData, VisibilityStore } from '../stores/VisibilityStore';
import { InputBox } from './InputBox';
import { VisibilityActions } from '../actions/VisibilityActions';
import { UIHelper } from '../utils/UIHelper';
import { GlobalHelper } from '../utils/GlobalHelper';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { ClickButton } from './ClickButton';

interface InputDialogState {
    data: DialogData | null;
}

export class InputDialog extends BaseComponent<{}, InputDialogState> {
    protected inputBox: InputBox;
    public componentWillMount(): void {
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.data != null) {
            if (this.state.data.clickedElement && this.state.data.type === 'length') {
                return (
                    <div className="floating-inputbox-overlay" onClick={this.onClose}>
                    <div
                        className="floating-inputbox"
                        onClick={UIHelper.stopEvent}
                        style={{
                            left: this.state.data.clickedElement.getBoundingClientRect().right,
                            top: this.state.data.clickedElement.getBoundingClientRect().top
                        }}
                    >
                        <InputBox
                            className="input-floating"
                            defaultValue={this.state.data.default}
                            ref={this.setInputBox}
                            focus={true}
                            inputType={this.state.data.type}
                            submitCallback={this.submit}
                            noTextHelper={this.state.data.noTextHelper}
                        />
                        <div className={'floating-inputbox-buttons'}>
                        <div
                            className={'floating-inputbox-left' + (GlobalHelper.roomManager.changeWallLengthToRight ? '' : ' floating-inputbox-active-button')}
                            onClick={this.onLeftClick}
                        />
                        <span>{t('Direction')}</span>
                        <div
                            className={'floating-inputbox-right' + (GlobalHelper.roomManager.changeWallLengthToRight ? ' floating-inputbox-active-button' : '')}
                            onClick={this.onRightClick}
                        />
                        </div>
                    </div>
                    </div>
                );
            }
            return (
                <div className="dialog-page" onClick={this.onClose}>
                    <div
                        className={'dialog-page-resizer' + (AppConfigurationStore.softKeyboard() ? ' dialog-page-resizer-softkeyboard' : '')}
                        onClick={UIHelper.stopEvent}
                    >
                        <div className="dialog-page-header">{this.state.data.label}</div>
                        <InputBox
                            className=""
                            defaultValue={this.state.data.default}
                            ref={this.setInputBox}
                            focus={true}
                            inputType={this.state.data.type}
                            submitCallback={this.submit}
                            noTextHelper={this.state.data.noTextHelper}
                        />
                        <ClickButton className="cancel-button" callback={this.onClose}>{t('Cancel')}</ClickButton>
                        <ClickButton
                            className="submit-button"
                            callback={this.submit}
                        >
                            {this.state.data.submitLabel ? this.state.data.submitLabel : t('OK')}
                        </ClickButton>
                    </div>
                </div>
            );
        }
        return null;
    }

    protected setInputBox = (node: InputBox): void => {
        this.inputBox = node;
    };

    protected onLeftClick = (): void => {
        GlobalHelper.roomManager.changeWallLengthToRight = false;
        this.setState(this.state);
   };

    protected onRightClick = (): void => {
        GlobalHelper.roomManager.changeWallLengthToRight = true;
        this.setState(this.state);
    };

    protected onChange = (): void => {
        this.setState({
            data: VisibilityStore.getState().dialog
        });
    };

    protected onClose = (): void => {
        if (this.state.data != null && this.state.data.closeCallback) {
            this.state.data.closeCallback();
        }
        VisibilityActions.closeDialog();
    };

    protected submit = (): void => {
        if (this.state.data != null && this.inputBox) {
            const value: string | number | null = this.inputBox.value;
            this.state.data.callback(value);
        }
        UIHelper.blurKeyboard();
        VisibilityActions.closeDialog();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/InputDialog.tsx